export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-19.822b0da7.png";